import { render, staticRenderFns } from "./QuestionMetricSlideNumber.vue?vue&type=template&id=2975d248&scoped=true&"
import script from "./QuestionMetricSlideNumber.vue?vue&type=script&lang=js&"
export * from "./QuestionMetricSlideNumber.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMetricSlideNumber.vue?vue&type=style&index=0&id=2975d248&lang=scss&scoped=true&"
import style1 from "./QuestionMetricSlideNumber.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2975d248",
  null
  
)

export default component.exports